module.exports = ['$timeout', function ($timeout) {
    return {
        restrict: "E",
        templateUrl: '/static/partials/components/pivot_table.html',
        replace: true,
        controller: "PdPivotTable",
        controllerAs: "pivot_table",
        link: function link($scope, $element, $attrs) {
            // ------------------
            // Drag & Drop
            // ------------------

            $scope.pivot_table.dragulaOptions = {
                accepts: function (el, target, source, sibling) {
                    if (angular.element(target).hasClass("fields-available")) {
                        return false;
                    }
                    return true; // elements can be dropped in any of the `containers` by default
                },
                copy: function (el, source) {
                    return angular.element(source).hasClass("fields-available");
                },
                moves: function (el, source, handle, sibling) {
                    if (angular.element(source).hasClass("fields-selected")) {
                        if (angular.element(source).find('.draggable-item').length == 1) {
                            return false;
                        }
                    }
                    return angular.element(handle).hasClass('draggable-handle'); // elements are always draggable by default
                },
                removeOnSpill: true
            };

            $scope.$on('fields.remove-model', function (e, el, target, source, sibling) {
                $scope.reportOptions.group_by = $scope.pivot_table.fields_selected.join(",");
                $timeout(function () {
                    $scope.pivot_table.updateAvailableFields();
                });
            });
            $scope.$on('fields.drop-model', function (e, el, target, source, sibling) {
                $scope.reportOptions.group_by = $scope.pivot_table.fields_selected.join(",");
            });


            $scope.$on('fields.over', function (event, el, container, source){
                var source = angular.element(source);
                var mirror = angular.element('body').find('.draggable-item.gu-mirror');

                if(source.hasClass("fields-selected")) {
                    mirror.find('.btn').removeClass("btn-danger");
                }
            });

            $scope.$on('fields.out', function (event, el, container, source) {
                var source = angular.element(source);
                var mirror = angular.element('body').find('.draggable-item.gu-mirror');

                if(source.hasClass("fields-selected")) {
                    mirror.find('.btn').addClass("btn-danger");
                }
            });
        }
    };
}];
